import { useLocation } from 'react-router-dom';
import IFrameLayout from 'components/layout/IFrameLayout';

const ReportDashboard = () => {
  const location = useLocation();
  const url = location?.state?.url;
  return (
      <IFrameLayout>
        <iframe
          src={url}
          title='dashboard'></iframe>
      </IFrameLayout>
  );
};

export default ReportDashboard;
